import { z } from 'zod';
import * as FlatModels from '../../internal';

export const BulkEditEntityType = z.enum([
	FlatModels.EntityControlModels.EntityQueryType.enum.MEDIA_ENTITY,
	FlatModels.EntityControlModels.EntityQueryType.enum.NODE_ENTITY,
	FlatModels.EntityControlModels.EntityQueryType.enum.PAGE_ENTITY,
	FlatModels.EntityControlModels.EntityQueryType.enum.LAYER_ENTITY,
	FlatModels.EntityControlModels.EntityQueryType.enum.IMAGE_ENTITY,
	FlatModels.EntityControlModels.EntityQueryType.enum.ANNOTATION_GROUP_ENTITY,
	FlatModels.EntityControlModels.EntityQueryType.enum.ANNOTATION_ENTITY,
	FlatModels.EntityControlModels.EntityQueryType.enum.QUESTION_ENTITY,
	FlatModels.EntityControlModels.EntityQueryType.enum.CHOICE_ENTITY,
	FlatModels.EntityControlModels.EntityQueryType.enum.POINT_OF_INTEREST_ENTITY,
]);
export type BulkEditEntityType = z.infer<typeof BulkEditEntityType>;

export const BulkEditEntityTypeCopyDescription: Record<string, string> = {
  [BulkEditEntityType.enum.MEDIA_ENTITY]: 'enum.copy.type.medias',
  [BulkEditEntityType.enum.NODE_ENTITY]: 'enum.copy.type.nodes',
  [BulkEditEntityType.enum.PAGE_ENTITY]: 'enum.copy.type.pages',
  [BulkEditEntityType.enum.LAYER_ENTITY]: 'enum.copy.type.layers',
  [BulkEditEntityType.enum.IMAGE_ENTITY]: 'enum.copy.type.images',
  [BulkEditEntityType.enum.ANNOTATION_GROUP_ENTITY]: 'enum.copy.type.groups',
  [BulkEditEntityType.enum.ANNOTATION_ENTITY]: 'enum.copy.type.annotations',
  [BulkEditEntityType.enum.QUESTION_ENTITY]: 'enum.copy.type.questions',
  [BulkEditEntityType.enum.CHOICE_ENTITY]: 'enum.copy.type.choices',
  [BulkEditEntityType.enum.POINT_OF_INTEREST_ENTITY]: 'enum.copy.type.pois',
}

export const BulkEditEntityTypeDescription: Record<string, string> = {
  [BulkEditEntityType.enum.MEDIA_ENTITY]: 'global.image',
  [BulkEditEntityType.enum.PAGE_ENTITY]: 'global.page',
  [BulkEditEntityType.enum.LAYER_ENTITY]: 'global.layer',
  [BulkEditEntityType.enum.IMAGE_ENTITY]: 'global.image',
  [BulkEditEntityType.enum.ANNOTATION_GROUP_ENTITY]: 'global.group',
  [BulkEditEntityType.enum.ANNOTATION_ENTITY]: 'global.annotation',
  [BulkEditEntityType.enum.QUESTION_ENTITY]: 'global.question',
  [BulkEditEntityType.enum.POINT_OF_INTEREST_ENTITY]: 'global.poi',
}

export const BulkEditEntityTypeIcon: Record<string, string> = {
	[BulkEditEntityType.enum.MEDIA_ENTITY]: FlatModels.ButtonDesignModels.ButtonDefaultIcons.MEDIA,
	[BulkEditEntityType.enum.PAGE_ENTITY]: FlatModels.ButtonDesignModels.ButtonDefaultIcons.PAGE_SLIDE,
	[BulkEditEntityType.enum.LAYER_ENTITY]: FlatModels.ButtonDesignModels.ButtonDefaultIcons.LAYER,
	[BulkEditEntityType.enum.IMAGE_ENTITY]: FlatModels.ButtonDesignModels.ButtonDefaultIcons.IMAGE,
	[BulkEditEntityType.enum.ANNOTATION_GROUP_ENTITY]: FlatModels.ButtonDesignModels.ButtonDefaultIcons.GROUP,
	[BulkEditEntityType.enum.ANNOTATION_ENTITY]: FlatModels.ButtonDesignModels.ButtonDefaultIcons.ANNOTATIONS,
	[BulkEditEntityType.enum.QUESTION_ENTITY]: FlatModels.ButtonDesignModels.ButtonDefaultIcons.QUESTION,
	[BulkEditEntityType.enum.POINT_OF_INTEREST_ENTITY]: FlatModels.ButtonDesignModels.ButtonDefaultIcons.SIGN_POST,
}

export const BulkEditMappingSchema = z.object({
	page: z.record(z.string().uuid(), z.string().uuid()),
	layer: z.record(z.string().uuid(), z.string().uuid()),
	image: z.record(z.string().uuid(), z.string().uuid()),
	group: z.record(z.string().uuid(), z.string().uuid()),
	poi: z.record(z.string().uuid(), z.string().uuid()),
	annotation: z.record(z.string().uuid(), z.string().uuid()),
});

export type BulkEditMapping = z.infer<typeof BulkEditMappingSchema>;

